<script setup lang="ts">
/**
 * Tous les événements d'une association — page publique « tout lister », partageable telle quelle.
 * Voir `AssoListeFeature` pour le pourquoi.
 */
const slug = (useRoute().params as { slug: string }).slug;
const { t } = useI18n();
</script>

<template>
  <AssoListeFeature
    :slug="slug"
    domaine="events"
    :titre="t('association.listeEvenements.titre')"
    :sous-titre="t('association.listeEvenements.sousTitre')"
    :message-vide="t('association.listeEvenements.messageVide')"
  />
</template>
